import {Component, OnInit, Output, EventEmitter, AfterViewInit} from '@angular/core';
import {BsModalRef, BsModalService} from 'ngx-bootstrap';
import {NewAccountComponent} from '../shared/new-account/new-account.component';
import {AccountsService} from '../../core/accounts/accounts.service';
import {MapService} from '../../core/map/map.service';
import {AuthService} from '../../core/auth/auth.service';
import {UtilsService} from '../../core/utils/utils.service';

@Component({
  selector: 'app-accounts',
  templateUrl: './accounts.component.html',
  styleUrls: ['./accounts.component.scss']
})
export class AccountsComponent implements OnInit, AfterViewInit {

  @Output() close = new EventEmitter();

  bsModalRef: BsModalRef;

  usersWithAccounts: any[];
  showLoader: Boolean = false;

  search = {
    name: ''
  };

  constructor(private modalService: BsModalService,
              private utilsService: UtilsService,
              private authService: AuthService,
              private accountsService: AccountsService,
              private mapService: MapService) { }

  ngOnInit() {
    this.accountsService.createAccount
      .subscribe((account: any) => {
        if (account) {
          this.usersWithAccounts = this.usersWithAccounts.map(ua => {
            if (ua.user._id === this.authService.getProfile()._id) {
              ua.accounts = [account, ...ua.accounts];
            }
            return ua;
          });

          this.mapService.addAccountMarker(account);
        }
      });

    this.accountsService.bulkCreateAccount
      .subscribe((accounts: any) => {
        if (accounts && this.usersWithAccounts) {
          accounts.forEach(account => {
            this.usersWithAccounts = this.usersWithAccounts.map(ua => {
              if (ua.user._id === this.authService.getProfile()._id) {
                ua.accounts = [account, ...ua.accounts];
              }
              return ua;
            });
            this.mapService.addAccountMarker(account);
          });
        }
      });

    this.accountsService.deleteAccount
      .subscribe((accountId) => {
        if (accountId) {
          this.usersWithAccounts = this.usersWithAccounts.map(ua => {
            if (ua.user._id === this.authService.getProfile()._id) {
              ua.accounts = ua.accounts.filter(a => a._id !== accountId);
            }
            return ua;
          });
        }
      });

    this.usersWithAccounts = [this.authService.getProfile(), ...this.authService.getProfile().children]
      .map(u => ({ user: u, active: true, collapsed: false, accounts: []}));
  }

  ngAfterViewInit() {
    this.getAccounts();
  }

  getAccounts() {
    this.accountsService.list()
      .subscribe((accounts: any[]) => {
        accounts.forEach(a => {
          this.usersWithAccounts.forEach(ua => {
            if (ua.user._id === a.createdBy) {
              ua.accounts.push(a);
            }
          });
        });

        if (this.usersWithAccounts.length > 1) {
          const userColors = [];
          this.usersWithAccounts.forEach(ua => {
            userColors.push({
              value: ua.user._id,
              accounts: ua.accounts,
              color: this.utilsService.stringToColor(ua.user._id)
            });
          });

          this.mapService.userColors = userColors;
        } else {
          this.mapService.userColors = [];
        }

        this.mapService.placeAccountMarkers(accounts);
      });
  }

  getColor(userId) {
    return this.mapService.userColors && this.mapService.userColors.find(c => c.value === userId) && this.mapService.userColors.find(c => c.value === userId).color;
  }

  getCaption(userWithAccounts) {
    if (userWithAccounts.user._id === this.authService.getProfile()._id) {
      return 'Your accounts';
    } else {
      return `Accounts by ${userWithAccounts.user.name}`;
    }
  }

  isActive(account) {
    return this.accountsService.selectedAccount === account;
  }

  isMultipleAccounts() {
    return this.usersWithAccounts.length > 1;
  }

  openAccountModal() {
    this.bsModalRef = this.modalService.show(NewAccountComponent);
  }

  toggleAccounts(userWithAccounts) {
    userWithAccounts.active = !userWithAccounts.active;
    this.mapService.filterAccountsByUsers(this.usersWithAccounts.filter(ua => !ua.active).map(ua => ua.user._id));
  }

  selectAccount(e, account) {
    this.accountsService.select(account);
    this.mapService.center(account.coords[1], account.coords[0]);
    e.preventDefault();
  }

  toggleUser(e, user) {
    user.collapsed = !user.collapsed;
  }

  exportAccounts() {
    this.showLoader = true;
    this.accountsService.export().then((result) => {
      this.showLoader = false;
    }).catch((error) => {
      this.showLoader = false;
    })
  }

}



// WEBPACK FOOTER //
// ./client/app/components/accounts/accounts.component.ts